/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const NatCal = require('../types/NatCal')
const kernel = require('../kernel/kernel')
const CValeur = require('./CValeur')
const CSuiteRec = require('./CSuiteRec')
module.exports = CSuiteRec3

/**
 * Suite récurrente réelle de la forme u(n+2)=f[n,u(n+1),u(n)] où f est une fonction réelle de trois variables.
 * @constructor
 * @extends CSuiteRec
 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
 * @param {Boolean} estElementFinal : true si élément final de construction.
 * @param {String} nomCalcul : Le nom de la suite.
 * @param {CFonc} fonctionAssociee : La fonction réelle de deux variables associée.
 * @param {CValeur} nombreTermes : Le nombre de termes de la suite (dynamique).
 * @param {CValeur} premierTerme : Le premier terme de la suite.
 * @param {CValeur} deuxiemeTerme : Le deuxième terme de la suite.
 * @returns {CSuiteRec3}
 */
function CSuiteRec3 (listeProprietaire, impProto, estElementFinal, nomCalcul, fonctionAssociee,
    nombreTermes, premierTerme, deuxiemeTerme) {
  if (arguments.length === 1) CSuiteRec.call(this, listeProprietaire);
  else {
    CSuiteRec.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul,
      fonctionAssociee, nombreTermes, premierTerme);
    this.deuxiemeTerme = deuxiemeTerme;
  }
}
CSuiteRec3.prototype = new CSuiteRec();
CSuiteRec3.prototype.constructor = CSuiteRec3;
CSuiteRec3.prototype.superClass = "CSuiteRec";
CSuiteRec3.prototype.className = "CSuiteRec3";

CSuiteRec3.prototype.getClone = function(listeSource, listeCible) {
  var ind1 = listeSource.indexOf(this.fonctionAssociee);
  var ind2 = listeSource.indexOf(this.impProto);
  var premierTermeClone = this.premierTerme.getClone(listeSource, listeCible);
  var deuxiemeTermeClone = this.deuxiemeTerme.getClone(listeSource, listeCible);
  var nombreTermesClone = this.nombreTermes.getClone(listeSource, listeCible);
  return new CSuiteRec3(listeCible, listeCible.get(ind2, "CImplementationProto"),
    this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CFoncNVar"), nombreTermesClone,
    premierTermeClone, deuxiemeTermeClone);
};
CSuiteRec3.prototype.initialisePourDependance = function() {
  CSuiteRec.prototype.initialisePourDependance.call(this);
  this.deuxiemeTerme.initialisePourDependance();
};
CSuiteRec3.prototype.dependDe = function(p) {
  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
  return this.memoriseDependance(CSuiteRec.prototype.dependDe.call(this, p)
    || this.deuxiemeTerme.dependDe(p));
};
CSuiteRec.prototype.dependDePourBoucle = function(p) {
  return CSuiteRec.prototype.dependDePourBoucle.call(this, p) || this.deuxiemeTerme.dependDePourBoucle(p);
};
CSuiteRec3.prototype.positionne = function(infoRandom, dimfen) {
  var u,v,w,i;
  this.nombreTermes.positionne(infoRandom, dimfen);
  this.premierTerme.positionne(infoRandom, dimfen);
  this.deuxiemeTerme.positionne(infoRandom, dimfen);
  this.existe = this.fonctionAssociee.existe && this.premierTerme.existe && this.nombreTermes.existe;
  if (!this.existe) return;
  var dnbt = Math.floor(this.nombreTermes.rendValeur(false) + 0.5);
  this.existe = (dnbt >= 1) && (dnbt <= kernel.NombreMaxiTermesSuiteRec);
  if (!this.existe) return;
  if (dnbt !== this.nbt) {
    this.nbt = dnbt;
    this.metAJourNombreTermes();
  }

  u = this.premierTerme.rendValeur();
  this.valeurs[0] = u;
  v = this.deuxiemeTerme.rendValeur();
  this.valeurs[1] = v;
  this.indiceDernierTermeExistant = 0;
  i = 2;
  while (i < this.nbt) {
    try {
      this.listeProprietaire.initialiseNombreIterations();
      // v = fonctionAssociee.calcul.resultatFonction(infoRandom, u);
      var arg = new Array(3);
      arg[0] = i - 2;
      arg[1] = v;
      arg[2] = u;
      w = this.fonctionAssociee.calcul.resultatFonction(true, arg);
      if (!isFinite(v)) break;
      u = v;
      v = w;
      this.valeurs[i] = w;
      i++;
    } catch (e) {
      break;
    }
  }
  i--;
  this.indiceDernierTermeExistant = i;
};
CSuiteRec3.prototype.getNatureCalcul = function() {
 return NatCal.NSuiteRecurrenteReelle3;
};
CSuiteRec3.prototype.read = function(inps, list){
  CSuiteRec.prototype.read.call(this, inps, list);
  this.deuxiemeTerme = new CValeur();
  this.deuxiemeTerme.read(inps, list);
};
CSuiteRec3.prototype.write = function(oups, list){
  CSuiteRec.prototype.write.call(this, oups, list);
  this.deuxiemeTerme.write(oups, list);
};



// WEBPACK FOOTER //
// ./src/objets/CSuiteRec3.js